import { render, staticRenderFns } from "./RenewalDate.vue?vue&type=template&id=56a7490a&"
import script from "./RenewalDate.vue?vue&type=script&lang=js&"
export * from "./RenewalDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports